import axios from "axios";
import store from "./store";
import createAuthRefreshInterceptor from "axios-auth-refresh";
let current = JSON.parse(localStorage.getItem("NGAccessTokens"));

// Point a local build at another API (e.g. the dev test environment) with
// VUE_APP_API_PREFIX=https://<id>.execute-api.eu-west-2.amazonaws.com/dev yarn serve
const API_PREFIX = process.env.VUE_APP_API_PREFIX || `https://api.numbersgame.uk`;

let data = {
  refresh_token: current ? current.refresh_token : false,
  userid: localStorage.getItem("NGUserID"),
};

// Sign the user out locally without losing their bet slip or preferences.
function clearAuth() {
  localStorage.removeItem("NGAccessTokens");
  localStorage.removeItem("NGUserID");
}

// Function that will be called to refresh authorization
const refreshAuthLogic = (failedRequest) => {
  axios
    .post(
      `${API_PREFIX}/user/refresh`,
      data,
      false
    )
    .then((tokenRefreshResponse) => {
      // console.log("UPDATED TOKEN RESPONSE", tokenRefreshResponse.data);
      if (tokenRefreshResponse.data) {
        store.commit("storeAccessTokens", tokenRefreshResponse.data);

        failedRequest.response.config.headers["Authorization"] =
          tokenRefreshResponse.data.id_token;
        window.location = window.origin;
      } else {
        clearAuth();
        window.location = window.origin;
      }
    })
    .catch((error) => {
      console.log("Got an error", error);
      clearAuth();
      window.location = window.origin;
    });
};

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, refreshAuthLogic);

const API = {
  get(path, auth, params) {
    console.log(`GET request for data from: ${path}`);
    if (auth) {
      if (auth.ALWAYSIGNOREAUTH) {
        delete axios.defaults.headers.get["Authorization"];
      } else {
        axios.defaults.headers.get["Authorization"] = `${auth.idToken}`;
      }
      if (auth.REMOVEPREFIX){
        return axios.get(`${path}`, params);
      }
    }
    return axios.get(`${API_PREFIX}${path}`, params);
  },

  post(path, auth, params) {
    if (auth) {
      axios.defaults.headers.post["Authorization"] = `${auth.idToken}`;
    }
    // console.log(
    //   `POST request to: ${path} with data: ${JSON.stringify(params)}`
    // );
    return axios.post(`${API_PREFIX}${path}`, params);
  },

  put(path, auth, params) {
    if (auth) {
      axios.defaults.headers.put["Authorization"] = `${auth.idToken}`;
    }
    return axios.put(`${API_PREFIX}${path}`, params);
  },

  delete(path, auth) {
    if (auth) {
      axios.defaults.headers.delete["Authorization"] = `${auth.idToken}`;
    }
    return axios.delete(`${API_PREFIX}${path}`);
  },
};

export default API;
